import { chakra, Input, Box } from "@chakra-ui/react";

const EnhancedLabel = chakra("label");
const filledStyle = {
  transform: "translate(-15%,-140%) scale(0.7)"
};

export default function TextField({
  value,
  onChange,
  type,
  elevationLevel = 0,
  inputProps,
  label,
  placeholder,
  autoFocus,
  required,
  disabled,
  name,
  reference,
  ...rest
}) {
  return (
    <Box pos="relative" {...rest}>
      <EnhancedLabel
        sx={
          label
            ? {
                span: {
                  pointerEvents: "none",
                  transition: "transform 0.2s",
                  top: "50%",
                  transform: "translateY(-50%)",
                  left: "1.5rem",
                  pos: "absolute",
                  fontSize: "14px",
                  bg:
                    elevationLevel === 0
                      ? "surface"
                      : `surfaceElevated${elevationLevel}`,
                  px: "4px",
                  zIndex: 2,
                  color: "mediumEmphasis",
                  ...(value && filledStyle)
                }
              }
            : undefined
        }
        _focusWithin={
          label
            ? {
                span: {
                  ...filledStyle,
                  color: "primary"
                }
              }
            : undefined
        }
      >
        {label && <span>{label}</span>}
        <Input
          ref={reference}
          name={name}
          required={required}
          autoFocus={autoFocus}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          {...inputProps}
        />
      </EnhancedLabel>
    </Box>
  );
}
